import { ChatBubbleLeftEllipsisIcon } from "@heroicons/react/24/outline";
import { Button } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper } from "src/shared/components";

import DirectoryBrowser from "./components/DirectoryBrowser";

const FEEDBACK_FORM_URL = "https://forms.gle/FoKtZYAGqD2BHR7s7";

const FeedbackLabel = styled.span`
  @media (max-width: 600px) {
    display: none;
  }
`;

const FeedbackIcon = styled(ChatBubbleLeftEllipsisIcon)`
  width: 18px;
  height: 18px;
`;

const HackerDirectoryDirectory: React.FC = () => (
  <>
    <Header
      title="Hacker Directory"
      subtitle="Looking for teammates? Browse for hackers that match your skills and interests!"
      actionButton={
        <Button
          aria-label="Share feedback about the Hacker Directory"
          color="secondary"
          leadingIcon={<FeedbackIcon aria-hidden />}
          onClick={() =>
            window.open(FEEDBACK_FORM_URL, "_blank", "noopener,noreferrer")
          }
          size="md"
          title="Share feedback about the Hacker Directory"
        >
          <FeedbackLabel>Share feedback</FeedbackLabel>
        </Button>
      }
    />
    <PageWrapper>
      <DirectoryBrowser />
    </PageWrapper>
  </>
);

export default HackerDirectoryDirectory;
